import { Box, styled } from '@/core/ui/muiReexports';
export const FullStretchCenteredBox = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
});
